import corruption_prevention_en from "./corruption-prevention-en.json";
import corruption_prevention_tc from "./corruption-prevention-tc.json";
import corruption_prevention_sc from "./corruption-prevention-sc.json";
import {
  CATEGORIES,
  MEDIA_TYPE,
  type PublicationType,
} from "../PublicationList_left";
import { Language } from "../../context";

/**
 * Transforms raw JSON entries into standardized PublicationType objects for the "Corruption Prevention" section.
 * All entries are treated as publications and categorized accordingly.
 *
 * @param jsonData - The raw JSON array from any language version of corruption prevention data
 * @returns An array of normalized PublicationType objects
 */

const processCorruptionPreventionJson = (
  jsonData: any[]
): PublicationType[] => {
  return jsonData?.map((item) => ({
    title: item?.title ?? "",
    date: item?.date ?? "",
    link: item?.url ?? "",
    external: item?.external === "true",
    mediaType: item?.type as MEDIA_TYPE, // PDF
    thumbnail: item?.thumb ?? "",
    category: [CATEGORIES.PUBLICATIONS],
  }));
};

// Generate corruption prevention lists for each language
const booklets_list_en: PublicationType[] = processCorruptionPreventionJson(
  corruption_prevention_en
);
const booklets_list_tc: PublicationType[] = processCorruptionPreventionJson(
  corruption_prevention_tc
);
const booklets_list_sc: PublicationType[] = processCorruptionPreventionJson(
  corruption_prevention_sc
);

/**
 * Maps each supported language to its corresponding corruption prevention publication list.
 */
export const corruptionPreventionLanguageMap: Record<
  Language,
  PublicationType[]
> = {
  [Language.EN]: booklets_list_en,
  [Language.TC]: booklets_list_tc,
  [Language.SC]: booklets_list_sc,
};
